import { datadogRum } from '@datadog/browser-rum';
import { getEnv } from './env';

const isFirefox = () =>
  typeof navigator !== 'undefined' &&
  /firefox/i.test(navigator.userAgent) &&
  !/seamonkey/i.test(navigator.userAgent);

const _ddEventsInjectCookieSize = event => {
  if (event.type === 'view') {
    const cookieSize = document.cookie.length;
    // eslint-disable-next-line camelcase
    event.context.cookie_size = cookieSize;
  }
};

/**
 * Intercept DD RUM events, add, manipulate and change events before they are sent to DD
 * @param {*} event - The DD event about to be sent
 * @param {*} context - The DD context to be appended to the event
 */
const beforeSend = (event, context) => {
  try {
    _ddEventsInjectCookieSize(event);
  } catch (error) {
    console.error('Error in beforeSend', error);
  }
};

const BASE_CONFIG = {
  site: 'datadoghq.com',
  service: 'auth-page',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  trackViewsManually: false,
  storeContextsAcrossPages: true,
  defaultPrivacyLevel: 'allow',
  compressIntakeRequests: false,
  // Use localStorage for session management in Firefox to avoid cookie restrictions
  ...(isFirefox()
    ? { sessionPersistence: 'local-storage' }
    : { usePartitionedCrossSiteSessionCookie: true }),
  beforeSend,
};

const APP_TOKENS = {
  app: {
    clientToken: 'pub043d733ee0f6877efd86e39c82b692aa',
    applicationId: 'cc0265f6-0370-4d05-b0d2-c64468a0a03b',
  },
  hq: {
    clientToken: 'pubd259cb671389bc35700ed75a568c2458',
    applicationId: '7bc8c79f-0308-479b-9499-4018635b06cd',
  },
};

export const initializeDatadog = () => {
  const { dimension, env } = getEnv();
  const config = APP_TOKENS[dimension];

  // TODO: Understand why for HQ the env is set to HQ and not production
  if (env !== 'production' && env !== 'hq') {
    return;
  }

  if (!config) {
    console.error(`Invalid Datadog dimension: ${dimension}`);
    return;
  }

  datadogRum.init({
    ...BASE_CONFIG,
    env: env === 'hq' ? 'production' : env,
    ...config,
  });
};

export { datadogRum };

export const reportErrorToDataDog = (error, context) => {
  try {
    datadogRum.addError(error, context);
  } catch (e) {
    console.error('Failed to report error to datadog', e);
  }
};

export const reportActionToDataDog = (action, context) => {
  try {
    datadogRum.addAction(action, context);
  } catch (e) {
    console.error('Failed to report action to datadog', e);
  }
};
